import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import home from 'assets/images/home.svg';
import AccountSwitcher from '../AccountSwitcher';
import './style.scss';



const AppBar = () => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const [opened, setOpened] = React.useState('');
  const [menuOpened, setMenuOpened] = React.useState(false);

  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  const id = userInfo.orgId || 1;
  const isPaused = userInfo?.isPaused;
  const { integrationsEnabled: isIntegrationsEnabled, integrations } = userInfo || {};
  const { hasUnpausedProjects } = userInfo?.personas || {};
  const userSubscription = userInfo?.billing?.planningSubscription;
  const { isTrial, isPromo, isExpired } = userSubscription || {};

  const isActive = !userInfo.isDisabled && !userInfo.isPaused && !userInfo.isCancel;

  const showScheduler = isIntegrationsEnabled && Array.isArray(integrations) && integrations.length > 0;

  // const getProfileImage = (userData) => {
  //   const { profileImage = null, profileImagePath = null, initials = null } = userData;
  //   if (profileImage) {
  //     const image_path = `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(
  //       profileImage,
  //       'full',
  //     )}`;
  //     return (
  //       <Avatar
  //         photo={image_path}
  //         size={35}
  //         borderSize={2}
  //       />
  //     );
  //   }
  //   if (profileImagePath) {
  //     return (
  //       <Avatar
  //         photo={profileImagePath}
  //         size={35}
  //         borderSize={2}
  //       />
  //     );
  //   }
  //   return (
  //     <Avatar
  //       text={initials}
  //       size={35}
  //       borderSize={2}
  //     />
  //   );

  // };

  const salesRoutes = [
    `/app/v2/${id}/leads`,
    `/app/v2/${id}/leads/status/current`,
    `/app/pro/${id}/documents/current`,
    `/app/pro/${id}/quotes/current`,
    `/app/pro/${id}/invoices`,
  ];

  const calendarRoutes = [
    '/app/v2/calendar',
    '/app/v2/scheduler',
  ];

  const goHome = (e) => {
    e.preventDefault();
    if (userSubscription) {
      window.open('/app/v2/projects', '_self');
    } else {
      window.open('/app', '_self');
    }
  };

  const handleClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      if (opened === e.target.id) {
        setOpened('');
      }
      else {
        setOpened(e.target.id);
      }
    }
  };

  const closeMenu = () => {
    setMenuOpened(false);
  };

  const closeMenuHandler = () => {
    setMenuOpened(false);
  };

  const openMenuHandler = () => {
    setMenuOpened(true);
  };

  const hasPermission = (permission) => {
    if (userInfo.permissions) {
      return userInfo.permissions[`${permission}`];
    }
  };

  const hasFeature = (feature) => {
    if (userInfo.features) {
      return userInfo.features?.includes(feature);
    }

    return false;
  };

  const hasWeddings = (minLength = 0) => {
    return userInfo.weddings?.length > minLength;
  };

  const showProjects = () => {
    // - If user is subscribed, show projects.
    // - If user is on unexpired trial or promo, show projects.
    // - If user has unpaused projects.
    if (userInfo.features && isActive || (isTrial || isPromo) && !isExpired) {
      // if ((hasFeature('PRO-PLANNING') && hasPermission('bookkeeper.view') && hasWeddings()) ||
      //   (hasFeature('PRO-PLANNING') && hasFeature('MP') && hasWeddings()) ||
      //   (hasFeature('MP') && hasWeddings())) return true;
      if (hasWeddings() || hasUnpausedProjects) return true;
      return hasFeature('PRO-PLANNING') && !hasPermission('bookkeeper.view');
    }
    return false;
  };

  const showCalendar = () => {
    if (userInfo.features && !userInfo.isDisabled) {
      return hasFeature('PRO-PLANNING') && hasPermission('calendar.view');
    }
    return false;
  };

  const showSalesTools = () => {
    if (userInfo.features) {
      return hasFeature('PRO-PLANNING') && hasPermission('lead.all');
    }
    return false;
  };

  const showContacts = () => {
    if (userInfo.features && !userInfo.isDisabled) {
      return userInfo.features?.includes('PRO-PLANNING') &&
        userInfo.permissions['contact.view'];
    }
    return false;
  };

  const ConditionalLink = ({ condition, navLink, aLink, children }) => {
    return condition ? aLink(children) : navLink(children);
  };

  const contentMenuItems = () => {
    return (
      <>
        {/* bookkeepers can only see invoices */}
        {isActive && (hasPermission('lead.view') ||
          hasPermission('bookkeeper.view')) &&
          !isPaused && !userInfo.isDisabled && (
          <li className={`menu-item ${opened === 'collapse-trigger-1' ? 'opened' : ''}`}>
            <ConditionalLink
              condition={!hasPermission('lead.view') && hasPermission('bookkeeper.view')}
              aLink={children => (
                <a
                  id="collapse-trigger-1"
                  href={`/app/pro/${id}/invoices`}
                  className={`appbar-option nav-link collapse-trigger
                              ${salesRoutes.includes(window.location.pathname) ? 'active' : '' }`}
                  onClick={e => handleClick(e)}
                >
                  {children}
                </a>
              )}
              navLink={children => (
                <NavLink
                  id="collapse-trigger-1"
                  className="appbar-option nav-link collapse-trigger"
                  to={`/app/v2/${id}/leads`}
                  isActive={(match, location) => {
                    if (salesRoutes.includes(location.pathname) ||
                      location?.pathname?.includes(`/app/v2/${id}/leads/status`)) {
                      return true;
                    }
                  }}
                  onClick={e => handleClick(e)}
                >
                  {children}
                </NavLink>
              )}
            >
              Sales
              <span
                className="fa fa-plus toggle-icon toggle-icon--closed"
              />
              <span
                className="fa fa-minus toggle-icon toggle-icon--opened"
              />
            </ConditionalLink>
            <ul
              className="dropdown-menu navbar-nav"
            >
              {/* <a
                    href={`/app/pro/${id}`}
                    className="appbar-avatar d-none d-md-inline-block"
                  >
                    {getProfileImage(userInfo)}
                  </a> */}
              {hasPermission('lead.view') && (
                <li>
                  <NavLink
                    className="appbar-option nav-link"
                    to={`/app/v2/${id}/leads`}
                    onClick={closeMenu}
                    isActive={(match, location) => {
                      return location?.pathname?.includes(`/app/v2/${id}/leads`);
                    }}
                  >
                    Leads
                  </NavLink>
                </li>
              )}
              {showSalesTools() && (
              <>
                <li>
                  <a
                    className="appbar-option nav-link"
                    href={`/app/pro/${id}/documents/current`}
                  >
                    Documents
                  </a>
                </li>
                <li>
                  <a className="appbar-option nav-link"
                    href={`/app/pro/${id}/quotes/current`}
                  >
                    Quotes
                  </a>
                </li>
              </>
                        )}
              {(showSalesTools() || hasPermission('bookkeeper.view')) && (
                <li>
                  <a
                    className="appbar-option nav-link"
                    href={`/app/pro/${id}/invoices`}
                  >
                    Invoices
                  </a>
                </li>
              )}
            </ul>
          </li>
        )}
        {showProjects() &&
          (
            <NavLink
              id="collapse-trigger-2"
              to="/app/v2/projects"
              className="appbar-option nav-link menu-item"
              isActive={(match, location) => {
                if (location.pathname === '/app/v2/projects') {
                  return true;
                }
              }}
              onClick={closeMenu}
            >
              Projects
            </NavLink>
          )
        }
        {showCalendar() && !isPaused && (
          <li className={clsx('menu-item', opened === 'collapse-trigger-3' && 'opened')}>
            <ConditionalLink
              condition={showScheduler}
              aLink={children => (
                <a
                  id="collapse-trigger-3"
                  href={`/app/pro/${id}/calendar`}
                  className={clsx(
                    'appbar-option',
                    'nav-link',
                    'collapse-trigger',
                    calendarRoutes.includes(window.location.pathname) && 'active',
                  )}
                  onClick={e => handleClick(e)}
                >
                  {children}
                </a>
              )}
              navLink={children => (
                <a
                  href={`/app/pro/${id}/calendar`}
                  className={clsx(
                    'appbar-option',
                    'nav-link',
                    calendarRoutes.includes(window.location.pathname) && 'active',
                  )}
                >
                  {children}
                </a>
              )}
            >
              Calendar
              {showScheduler && (
              <>
                <span
                  className="fa fa-plus toggle-icon toggle-icon--closed"
                />
                <span
                  className="fa fa-minus toggle-icon toggle-icon--opened"
                />
              </>
              )}

            </ConditionalLink>
            <ul
              className="dropdown-menu navbar-nav"
            >
              <>
                <li>
                  <a
                    id="calendar-tab"
                    href={`/app/pro/${id}/calendar`}
                    className="appbar-option nav-link menu-item"
                  >
                    Calendar
                  </a>
                </li>
                {showScheduler && (
                  <li>
                    <NavLink
                      id="scheduler-tab"
                      to="/app/v2/scheduler"
                      className="appbar-option nav-link menu-item"
                      isActive={(match, location) => location.pathname === '/app/v2/scheduler'}
                    >
                      Scheduling
                    </NavLink>
                  </li>
                )}
              </>
            </ul>
          </li>
        )}
        {showContacts() && !isPaused &&
          (
            <li className="menu-item">
              <a
                className="appbar-option nav-link"
                href={`/app/pro/${id}/contacts`}
              >
                Contacts
              </a>
            </li>
          )
        }
      </>
    );
  };

  return (
    <section className="navbar-container">
      <div
        className="color-appbar navbar"
      >
        <div className="navbar-nav d-md-none">
          <div className="navbar-item navbar-dropdown-item">
            <div className="mobile-navbar-toggle">
              <a className="mobile-navbar-toggle__button nav-link"
                onClick={() => openMenuHandler()}
              >
                <span className="fa fa-bars" />
              </a>
            </div>
          </div>
        </div>
        <div className={`navbar-wrapper ${menuOpened ? 'show' : ''}`}
          id="ap-navbar"
        >
          <div className="mobile-navigation-header d-md-none">
            <div className="close-trigger">
              <a
                className="close-trigger__button"
                onClick={() => closeMenuHandler()}
                aria-label="close"
              >
                <span className="fa fa-times" />
              </a>
            </div>
          </div>
          <div className="navbar-nav main-navigation">
            <ul
              className="navbar-nav mr-auto"
            >
              <li className="navbar-item navbar-title d-none d-md-block">
                <a
                  href="#"
                  onClick={goHome}
                  className="appbar-option nav-link"
                >
                  <img src={home}
                    alt="home"
                  />
                </a>
              </li>
              <AccountSwitcher/>
              {contentMenuItems()}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

AppBar.propTypes = {};
AppBar.defaultProps = {};

export default AppBar;
